const OTHERS_SEGMENT_NAMES = new Set(["others", "outros"]);

export default function isOthersSegment(node: { name: string }) {
  return OTHERS_SEGMENT_NAMES.has(node.name.trim().toLowerCase());
}
